import moment from 'moment'

const HOURS = Array.from({ length: 24 }, (_, i) => i + 1)

const METRICS = [
  { key: 'ndc', label: 'NDC', prefix: 'ndc', rowOrder: 1 },
  { key: 'gross', label: 'Gross Generation', prefix: 'gross', rowOrder: 2 },
  { key: 'ss', label: 'Station/Aux Service', prefix: 'ss', rowOrder: 3 },
  { key: 'netGen', label: 'Net Generation', prefix: 'netGen', rowOrder: 4 },
  { key: 'drl', label: 'DRL', prefix: 'drl', rowOrder: 5 },
]

const fmtAux = v => (v != null ? Number(v).toFixed(1) : '-')

export const sortByRowOrder = rows =>
  [...rows].sort((a, b) => (a.rowOrder ?? 999) - (b.rowOrder ?? 999))

export const dataToRows = data => {
  if (!data) return []
  return METRICS.map(({ label, prefix, rowOrder }) => {
    const row = { metric: label, rowType: 'metric', rowOrder }
    HOURS.forEach(h => {
      row[`h${h}`] = data[`${prefix}${h}`] ?? ''
      if (prefix === 'ss') {
        const on = data[`onlineAux${h}`]
        const off = data[`offlineAux${h}`]
        if (on != null || off != null)
          row[`ssTooltip_h${h}`] = `Type\tValue\nOnline Aux\t${fmtAux(
            on
          )}\nOffline Aux\t${fmtAux(off)}`
      }
    })
    row.h2a = data[`${prefix}2a`] ?? ''
    if (prefix === 'ss') {
      const on = data.onlineAux2a
      const off = data.offlineAux2a
      if (on != null || off != null)
        row.ssTooltip_h2a = `Type\tValue\nOnline Aux\t${fmtAux(
          on
        )}\nOffline Aux\t${fmtAux(off)}`
    }
    return row
  })
}

export const eventsToRows = (events, ccList) => {
  const ccMap = {}
  if (ccList)
    ccList.forEach(cc => {
      ccMap[String(cc.causeCode)] = cc.description
    })

  const groups = {}
  events.forEach(e => {
    const key = `${e.utility}|${e.unit}|${e.eventType}|${e.causeCode}`
    if (!groups[key]) groups[key] = []
    groups[key].push(e)
  })

  return Object.values(groups)
    .sort((a, b) => {
      const et = (a[0].eventType || '').localeCompare(b[0].eventType || '')
      if (et !== 0) return et
      return (Number(a[0].causeCode) || 0) - (Number(b[0].causeCode) || 0)
    })
    .map((groupEvents, index) => {
      const first = groupEvents[0]
      const ccDesc = ccMap[String(first.causeCode)] || ''
      const descriptions = [
        ...new Set(groupEvents.map(e => e.description).filter(Boolean)),
      ]
      const descStr = descriptions.join(' | ')
      const metric = `${first.eventType} (${first.causeCode}${
        ccDesc ? ` - ${ccDesc}` : ''
      })${descStr ? ` | ${descStr}` : ''}`

      const eventDataMap = {}
      groupEvents.forEach(e => {
        const h = e.eventStart ? moment(e.eventStart).hour() + 1 : null
        if (h >= 1 && h <= 24) {
          if (!eventDataMap[h]) eventDataMap[h] = []
          eventDataMap[h].push(e)
        }
      })

      const row = {
        metric,
        rowType: 'event',
        rowOrder: 100 + index,
        eventData: first,
        eventDataMap,
      }

      Object.entries(eventDataMap).forEach(([h, evs]) => {
        const hasAny = evs.some(e => e.availCap != null)
        if (!hasAny) {
          row[`h${h}`] = ''
          return
        }

        const sum = evs.reduce((s, e) => {
          const v = e.availCap != null ? parseFloat(e.availCap) : 0
          return s + (isNaN(v) ? 0 : v)
        }, 0)
        row[`h${h}`] = sum

        const sorted = evs
          .slice()
          .sort(
            (a, b) =>
              moment(a.eventStart).minute() - moment(b.eventStart).minute()
          )
        const weighted = sorted.reduce((s, e, i) => {
          const minStart = moment(e.eventStart).minute()
          const minEnd =
            i < sorted.length - 1
              ? moment(sorted[i + 1].eventStart).minute()
              : 60
          const cap = e.availCap != null ? parseFloat(e.availCap) : 0
          return s + cap * ((minEnd - minStart) / 60)
        }, 0)
        row[`h${h}_w`] = weighted
      })

      return row
    })
}
